module.exports = __webpack_public_path__ + "components/country-flag/static/xk-e3d6518ae6851277fd98cba82553681a.svg";